import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 7 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 4\" id=\"arrow-down\">\n  <path fill-rule=\"evenodd\" d=\"M285.807,105.935l-2.932,2.874a0.561,0.561,0,0,1-.786,0l-2.931-2.874a0.543,0.543,0,0,1,0-.775,0.561,0.561,0,0,1,.786,0l2.538,2.489,2.539-2.489a0.561,0.561,0,0,1,.786,0A0.543,0.543,0,0,1,285.807,105.935Z\" transform=\"translate(-279 -105)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/arrow-down.svg
// module id = null
// module chunks = 